var commonAll = /** @class */ (function () {
    function commonAll() {
    }
    commonAll.STORE_MODULE_NAME = 'commonAll';
    return commonAll;
}());
export { commonAll };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/commonAll/lib/commonAll.cls.ts
// module id = null
// module chunks = 